import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { Metrics } from '../utils/Metrics';

// only expected to be unknown in jest
let packageName = 'unknown';

try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  packageName = require('current-package-loader!').name;
} catch (e) {
  // ignore
}

let hasSeenReady = false;

/**
 * Emit metrics to help find places where apps aren't properly configured to
 * switch over to foundations components
 */
export function useFoundationsReadinessTracking() {
  const theme: null | unknown = useTheme();

  useEffect(() => {
    const dimensions: Record<string, string> = {
      hasSeenReady: `${hasSeenReady}`,
      packageName,
    };

    try {
      dimensions.templateBasename =
        // eslint-disable-next-line hubspot-dev/hubspot-is-special
        (window?.hubspot as any)?.bender?.templateBasename ?? 'unknown';
    } catch (e) {
      /* ignore */
    }

    try {
      const isProbablySetUpForFoundationsComponents =
        typeof theme === 'object' &&
        Object.keys(theme ?? {}).includes('color') &&
        typeof (theme as any).color === 'object' &&
        Object.keys((theme as any).color ?? {}).includes(
          'icon-core-on-fill-default'
        );

      if (isProbablySetUpForFoundationsComponents) {
        hasSeenReady = true;
        delete dimensions.hasSeenReady;
      }

      dimensions.result = `${isProbablySetUpForFoundationsComponents}`;
    } catch (__e) {
      // It's fine, this is very best effort,
      // we just don't want to ever crash an app.
      // If we threw, then this app probably isn't set up though.
      dimensions.result = 'false';
      dimensions.error = 'true';
    }
    Metrics.counter('foundations-theme-ready', dimensions).increment();
  }, [theme]);
}
